/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/rental`, controller.rental, makeLayout, render);
    router(`/dashboard/rental/edit`, controller.editRental, makeLayout, render);
};
